var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('feature-card-basic',{attrs:{"layer":_vm.layer},on:{"update:feature":_vm.onFeatureUpdate},scopedSlots:_vm._u([(_vm.widgetVisible)?{key:"top",fn:function(){return [_c('feature-joins',{attrs:{"layer-id":_vm.layerId,"feature-id":_vm.currentFeatureId,"values":_vm.values}})]},proxy:true}:null],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }